











































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() mainEquipId!: number;

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '你确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch('equipment/addsalecounter', {
              stadium_id: this.stadiumId,
              equipment_main_id: this.mainEquipId,
              ...fieldValues,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
